import "../../styles/variables.css";
import styled from 'styled-components';

//this is a box that we can put selectable shit in
//as of alpha design, it has organge borders and drop shadows
const FlavorText = styled.span`
    color: var(--jargon-primary);
    font-style:italic;
    font-weight:700;
`;
export default FlavorText;